/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import {ValidatorFn, Validators} from "@angular/forms";

export interface BaseCommentUser { 
    readonly id: number;
    readonly name: string;
    readonly email: string;
    readonly isTherapist: boolean;
    readonly isPatientops: boolean;
}
export const BaseCommentUser_id_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BaseCommentUser_name_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BaseCommentUser_email_Validators: ValidatorFn[] =
    [  Validators.required,  Validators.email,];

export const BaseCommentUser_isTherapist_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BaseCommentUser_isPatientops_Validators: ValidatorFn[] =
    [  Validators.required, ];


